import { Component, OnInit } from '@angular/core'
import BaseListComponent from 'src/app/class/BaseListComponent'
import { NgForm } from '@angular/forms'
import { DatePipe } from '@angular/common'

@Component({
  selector: 'app-unfinished-maintenance',
  templateUrl: './list.component.html',
  styleUrls: ['../../app.component.css']
})
export default class ListComponent extends BaseListComponent implements OnInit {
  data: any
  activeItem: any
  datum = {from: null, to: null, unfinished: 1}

  getHeading() {
    return 'Rozpracovaná údržba'
  }

  getCommEntity() {
    return this.comm.maintenance()
  }

  ngOnInit() {
    const prevQ = new Date(new Date().setDate(new Date().getDate()-90))
    const nextQ = new Date(new Date().setDate(new Date().getDate()+90))
    this.datum = {
      from: new DatePipe('en-US').transform(prevQ, 'yyyy-MM-dd'),
      to: new DatePipe('en-US').transform(nextQ, 'yyyy-MM-dd'),
      unfinished: 1
    }
    super.ngOnInit()
  }

  loadData() {
    this.entityComm.index(this.datum).subscribe(
      (response) => {
        const responseData = response.json()
        if (!responseData.error) {
          this.data = responseData
        }
      },
      (error) => {
        const message = (error.json() || {}).message ? error.json().message : 'Chyba při načítání dat'
        this.notifier.notify('error', message)
        console.error({error})
      }
    );
  }

  onSubmit(form:NgForm){
    if (form.value.from!='') {this.datum.from = form.value.from}
    if (form.value.to!='') {this.datum.to = form.value.to}
    this.refresh()
  }
}
